import { styled } from "@mui/material";
import dayjs from "dayjs";
import AppRoutes from "../../config/AppRoutes";
import { getRateLockPeriod } from "../../util/fetch/getRateLockPeriod";

export const RowWrapper = styled("div")(({ customStyle }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "10px",
  ...customStyle,
}));
export const CustomRowWrapper = styled("div")(({ customStyle }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: "20px",
  ...customStyle,
}));
export const RowLeftWrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  fontSize: "10px",
  gap: "10px",
  marginLeft: "10px",
});
export const ColumnWrapper = styled("div")(({ customStyle }) => ({
  display: "flex",
  flexDirection: "column",
  ...customStyle,
}));
export const isFirstTimeHomebuyerOptions = [
  { label: "First-time homebuyer", value: true },
  { label: "Repeat homebuyer", value: false },
];
export const lookingToOptions = [
  { label: "Buy my next home", value: "Purchase" },
  { label: "Build my next home", value: "Build" },
  { label: "Refinance my home", value: "Refinance" },
  { label: "Refinance and cash out", value: "RefinanceAndCashOut" },
];
export const propertyTypeOptions = [
  { label: "Single Family", value: "Single" },
  { label: "Townhouse", value: "Townhome" },
  { label: "Condo", value: "Condo" },
  { label: "Duplex", value: "Duplex" },
  { label: "Triplex", value: "Triplex" },
  { label: "Quadplex", value: "Quadplex" },
];
export const rateLockOptions = [
  {
    label: "30 days",
    value: dayjs().add(30, "day").format("MM/DD/YYYY"),
  },
  {
    label: "45 days",
    value: dayjs().add(45, "day").format("MM/DD/YYYY"),
  },
  {
    label: "60 days",
    value: dayjs().add(60, "day").format("MM/DD/YYYY"),
  },
  {
    label: "75 days",
    value: dayjs().add(75, "day").format("MM/DD/YYYY"),
  },
  {
    label: "90 days",
    value: dayjs().add(90, "day").format("MM/DD/YYYY"),
  },
];
export const getIsRefinance = (lookingTo) => {
  if (lookingTo) {
    return lookingTo === "Refinance";
  }
  const currentUrl = window.location.href.replace(
    process.env.REACT_APP_URL,
    ""
  );
  return currentUrl === AppRoutes.REFINANCE_IRQ_COMPARE_PAGE;
};

export const getIsRefinanceAndCashOut = (lookingTo) => {
  if (lookingTo) {
    return lookingTo === "RefinanceAndCashOut";
  }
  const currentUrl = window.location.href.replace(
    process.env.REACT_APP_URL,
    ""
  );
  return currentUrl === AppRoutes.REFINANCE_IRQ_COMPARE_PAGE;
};

export const getIsPurchase = (lookingTo) => {
  if (lookingTo) {
    return lookingTo === "Purchase";
  }
  const currentUrl = window.location.href.replace(
    process.env.REACT_APP_URL,
    ""
  );
  return currentUrl === AppRoutes.PURCHASE_IRQ_COMPARE_PAGE;
};

export const getIsBuild = (lookingTo) => {
  if (lookingTo) {
    return lookingTo === "Build";
  }
  const currentUrl = window.location.href.replace(
    process.env.REACT_APP_URL,
    ""
  );
  return currentUrl === AppRoutes.BUILD_IRQ_COMPARE_PAGE;
};

export const adaptClosingDateToRateLockOptions = (plannedClosingDate) => {
  if (!plannedClosingDate) {
    return "";
  }
  let rateLockPeriod = getRateLockPeriod(plannedClosingDate);
  if (rateLockPeriod === 15) {
    rateLockPeriod = 30;
  }
  const value = dayjs().add(rateLockPeriod, "day").format("MM/DD/YYYY");
  const index = rateLockOptions.findIndex((element) => element.value === value);
  if (index === -1) {
    return "";
  }

  return value;
};

export const occupancyTypeOptions = [
  { label: "Primary Residence", value: "Primary" },
  { label: "Vacation Home", value: "Secondary" },
  { label: "Rental", value: "Rental" },
];
export const ProfileWrapper = styled("div")({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "14px",
  marginLeft: "100px",
  color: "white",
  height: "70px",
  fontWeight: "bold",
  borderBottom: "1px solid rgba(255, 255, 255, 0.3)",
});
export const InputsWrapper = styled("div")`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
  color: white;
  padding: 20px;

  .MuiFormControl-root {
    flex: 1;
  }
`;
export const InputsLeftWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  color: white;

  .MuiFormControl-root {
    flex: 1;
    width: 100%;
    max-width: unset;
  }
`;
export const BottomInputsWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 20px;
`;
export const BottomWrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  marginBottom: "40px",
  gap: "10px",
  maxWidth: 380,
  minWidth: 320,
  padding: "40px 20px 20px 20px",
});
export const LoanTypesMobileWrapper = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
  padding: "20px",
});
export const BottomText = styled("div")({
  textAlign: "center",
  color: "white",
  fontSize: "10px",
  fontFamily: "proxima-nova, sans-serif",
  padding: "0 20px",
});
export const EditWrapper = styled("div")({
  position: "relative",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  paddingLeft: "2vw",
});
